import {
  AttendanceDataForm,
  AttendanceSessionPayload,
} from './componenets/attendance-data-form';
import React, { useMemo } from 'react';
import { LectureDetails } from '../../../../../../api/types/lecturers/details/lecture-details';
import { updateAttendanceOperations } from './operations/update-attendance-operations';
import globalProgramStore from '../../../../../../stores/program-store';
import globalLectureBuilderStore from '../../../../../../stores/global-lecture-builder-store';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

interface AttendanceLessonStartedDataFormDataModel {
  lectureDetails: LectureDetails;
}
export const AttendanceLessonStartedDataForm: React.FC<
  AttendanceLessonStartedDataFormDataModel
> = ({ lectureDetails }) => {
  const sessions = useMemo(
    () => lectureDetails?.attendanceSessions ?? [],
    [lectureDetails],
  );

  const students = useMemo<UserSummaryType[]>(() => {
    const byId = new Map<number, UserSummaryType>();
    sessions.forEach((sessionEntry) => {
      sessionEntry.attendance.forEach((row) => {
        if (!byId.has(row.student.id)) {
          byId.set(row.student.id, row.student);
        }
      });
    });
    return Array.from(byId.values());
  }, [sessions]);

  const lecture = useMemo(
    () => globalLectureBuilderStore.selectedLecture,
    [globalLectureBuilderStore.selectedLecture],
  );

  const handleCompleteLecture = async (
    sessionDelta: AttendanceSessionPayload[],
  ) => {
    const upsertPayload = sessionDelta.map((entry) => ({
      attendanceSessionsId: entry.sessionId,
      attendance: entry.attendance,
    }));

    const programId = globalProgramStore.getCurrentId();
    await updateAttendanceOperations(programId, lecture, upsertPayload);
  };

  return (
    <div>
      <AttendanceDataForm
        sessions={sessions}
        students={students}
        handleCompleteLecture={handleCompleteLecture}
      />
    </div>
  );
};
